import React from 'react';
import { DiamondIcon } from './Icons';
export const SymptomsChecklist = () => {
  const symptoms = ['You wake up exhausted even after a full night of sleep', 'Brain fog — forgetting words, losing your train of thought', 'Mood shifts for no apparent reason', 'Weight accumulates around your belly despite eating well', 'Irregular, painful, or unpredictable cycle', 'You feel bloated almost all the time', 'Your hair is thinning or falling out more', 'Your libido has disappeared', 'Anxiety or waking up at 3am with a racing mind'];
  return <section className="w-full bg-light py-8 md:py-12 px-4 md:px-6" data-id="element-183">
      <div className="max-w-[780px] mx-auto" data-id="element-184">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-185">
          Do You Recognize Any of These Symptoms?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-186">
          {symptoms.map((symptom, index) => <div key={index} className="bg-white border-l-[4px] border-medium rounded-[8px] p-4 md:px-5 md:py-4 shadow-[0_2px_8px_rgba(149,125,173,0.12)] flex items-start gap-3" data-id="element-187">
              <div className="mt-1 flex-shrink-0" data-id="element-188">
                <DiamondIcon color="#957DAD" size={16} data-id="element-189" />
              </div>
              <p className="font-lato text-[16px] text-body leading-snug" data-id="element-190">
                {symptom}
              </p>
            </div>)}
        </div>

        <div className="bg-medium rounded-[12px] py-6 px-8 mt-8 text-center" data-id="element-191">
          <p className="font-lato font-bold text-[18px] text-white leading-relaxed" data-id="element-192">
            If you identified with 3 or more... you are not just stressed.
            <br data-id="element-193" />
            You have a real hormonal imbalance. And it has a solution.
          </p>
        </div>
      </div>
    </section>;
};